import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PolteqTextField = _resolveComponent("PolteqTextField")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_PolteqButton = _resolveComponent("PolteqButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    id: "changePasswordForm",
    ref: "changePasswordForm"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
            "field-id": "passwordField",
            label: _ctx.i18n.t('fields.password'),
            rules: [_ctx.rules.required],
            type: "password",
            autocomplete: "current-password",
            icon: "mdi-lock-alert-outline"
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.newPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event)),
            "field-id": "newPasswordField",
            label: _ctx.i18n.t('fields.newpassword'),
            rules: [_ctx.rules.password],
            type: "password",
            autocomplete: "new-password",
            icon: "mdi-lock-check-outline"
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.confirmPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event)),
            "field-id": "confirmPasswordField",
            label: _ctx.i18n.t('fields.confirmpassword'),
            rules: [_ctx.rules.password_match(_ctx.newPassword, _ctx.confirmPassword)],
            type: "password",
            autocomplete: "new-password",
            icon: "mdi-lock-check-outline"
          }, null, 8, ["modelValue", "label", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { style: {"text-align":"end"} }, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqButton, {
            "button-id": "changePasswordButton",
            icon: "mdi-lock-open-plus-outline",
            "button-text": _ctx.i18n.t('buttons.changepassword'),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePassword(_ctx.password, _ctx.newPassword)))
          }, null, 8, ["button-text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}